import React, {Component} from "react";
import styled from "styled-components";
import {X} from "react-feather";
import {Check} from "react-feather";

import {
  primary,
  shadowHover,
  SmallMargin,
  InfoParagraph,
  grayText,
  shakeAnim,
  MediumTitle,
  mediaMaxPhone,
  AttentionTitle,
  Policy
} from "../Tools/Variables";

const ShowWrapper = styled.div `
  visibility: ${props => (props.show
  ? "visible"
  : "hidden")};
  opacity: ${props => (props.show
  ? "1"
  : "0")};
  max-width: 1500px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  height: 90vh;
  z-index: 9999;
  @media screen and (${mediaMaxPhone}) {
    width: 100vw;
    height: 90vh;
  }
`;

const Wrapper = styled.div `
  color: ${grayText};
  overflow-y: auto;
  padding: 10%;
  box-sizing: border-box;
  background: ${primary};
  box-shadow: ${shadowHover};
  max-width: 1500px;
  position: fixed;
  width: 100%;
  height: 100%;
`;

const Background = styled.div `
  transition: opacity 1s ease-in-out;
  visibility: ${props => (props.show
  ? "visible"
  : "hidden")};
  opacity: ${props => (props.show
  ? "0.8"
  : "0")};
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #333;
`;

const Checkbox = styled.div `
  flex-shrink: 0;
  position: relative;
  display: inline-block;
  height: 30px;
  width: 30px;
  border: 1px solid black;
  margin-right: 10px;
  vertical-align: sub;
  text-align: center;
  line-height: 33px;
  animation-name: ${props => (props.shake
  ? shakeAnim
  : "")};
  animation-duration: 0.8s;
`;

const CloseWrapper = styled.div `
  z-index: 99999;
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 0px;
  height: 80px;
  width: 80px;
  text-align: center;
  line-height: 80px;
  transition: 0.2s ease-in-out;
  transform-origin: center;
  :hover {
    opacity: 0.5;
    transform: scale(1.1, 1.1);
  }
`;

const BtnWrapper = styled.div `
  transition: 0.5s ease-in-out;

  transform: ${props => (props.active
  ? "translateY(0)"
  : "translateY(15px)")};
  opacity: ${props => (props.active
  ? "1"
  : "0.3")};
`;

const SubText = styled.div `
font-size:18px;

@media screen and (max-width:400px)  {
  font-size:13px;
  font-weight:500;

  
}
`;
const AcceptText = styled.div `

@media screen and (max-width:400px)  {
  font-size:13px;

  
}
  
`;
export class InterestedBody extends Component {
  state = {
    accepted: false,
    shake: false,
    sent: false
  };

  switchAccepted = () => {
    this.setState((prev, props) => ({
      accepted: !prev.accepted
    }));
  };

  setShake = () => {
    this.setState({shake: true});
    setTimeout(() => this.setState({shake: false}), 1000);
  };

  handleSubmit = () => {
    this
      .props
      .setHideContactModal();
    this.setState({sent: true});
  };

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this
        .props
        .setHideContactModal();

    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  render() {
    var URL = window.location.href;

    var sourceStr = "utm_source=";
    if (URL.includes(sourceStr)) {
      var utm_source = URL.substring(URL.indexOf(sourceStr) + sourceStr.length, URL.indexOf("&", URL.indexOf(sourceStr)));
    } else {
      var utm_source = null;
    }

    var mediumStr = "utm_medium=";
    if (URL.includes(mediumStr)) {
      var utm_medium = URL.substring(URL.indexOf(mediumStr) + mediumStr.length, URL.indexOf("&", URL.indexOf(mediumStr)));
    } else {
      var utm_medium = null;
    }

    var campaignStr = "utm_campaign=";
    if (URL.includes(campaignStr)) {
      var utm_campaign = URL.substring(URL.indexOf(campaignStr) + campaignStr.length, URL.indexOf("&", URL.indexOf(campaignStr)));
    } else {
      var utm_campaign = null;
    }

    var contentStr = "utm_content=";
    if (URL.includes(contentStr)) {
      var utm_content = URL.substring(URL.indexOf(contentStr) + contentStr.length);
    } else {
      var utm_content = null;
    }

    this.MailAction = "https://barkh.us19.list-manage.com/subscribe/post?u=b0f2b4bdcd6c96f8c06cdb49d&am" +
        "p;id=9f119bc297" + (utm_source != null
      ? "&SOURCE=" + utm_source
      : "") + (utm_medium != null
      ? "&MEDIUM=" + utm_medium
      : "") + (utm_campaign != null
      ? "&CAMPAIGN=" + utm_campaign
      : "") + (utm_content != null
      ? "&CONTENT=" + utm_content
      : "");

    console.log("src", utm_source);
    console.log("Medium", utm_medium);
    console.log("Campain", utm_campaign);
    console.log("Content", utm_content);
    console.log("Content", this.MailAction);

    return (
      <div id="mc_embed_signup">
        <SubText>
          <InfoParagraph
            style={{
            maxWidth: 600,
            fontSize: 'inherit',
            fontWeight: 'inherit'
          }}>

            Intresserad? Håll dig uppdaterad om den annalkande sängrevolutionen och få
            förtur på kollektionen. Ta kontroll över din
            sömn.
          </InfoParagraph>
        </SubText>

        <form
          action={this.MailAction}
          onSubmit={() => this.handleSubmit()}
          onKeyPress={event => {
            if (event.which === 13 /* Enter */) {
              event.preventDefault();
            }}}
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          target="_blank"
          novalidate>
          <div id="mc_embed_signup_scroll">
            <input
              placeholder="email"
              className="input"
              type="email"
              name="EMAIL"
              id="mce-EMAIL"/>
            <SmallMargin/>
            <div
              style={{
              display: "flex",
              alignItems: "center"
            }}
              onClick={this.switchAccepted}>
              <Checkbox shake={this.state.shake}>
                <div
                  style={{
                  opacity: this.state.accepted
                    ? 1
                    : 0
                }}>
                  <Check size={15}/>
                </div>
              </Checkbox>
              <div>
                {" "}
                <AcceptText>

                  Godkänn att vi skickar dig information & marknadsföring via email
                </AcceptText>
              </div>
            </div>
            <SmallMargin/>

            <fieldset
              name="interestgroup_field"
              style={{
              display: 'none'
            }}>
              <label className="checkbox subfield" for="gdpr_2475">
                <input
                  type="checkbox"
                  id="gdpr_2475"
                  name="gdpr[2475]"
                  value="Y"
                  className="av-checkbox gdpr"
                  checked={this.state.accepted}/>
              </label>
            </fieldset>
            <InfoParagraph
              style={{
              fontSize: 12,
              maxWidth: 400
            }}>
              <p>
                Du kan säga upp din prenumeration när som helst genom via länken längst ned i
                våra mail. Vi tar din integritet på allvar. Genom att skicka in formuläret så
                godkänner du vår
                <a target="_blank" href={Policy}>
                  Integritetspolicy. LÄS MER
                </a>.
              </p>

            </InfoParagraph>
            <div
              style={{
              position: "absolute",
              left: " -5000px"
            }}
              aria-hidden="true">
              <input
                type="text"
                name="b_b0f2b4bdcd6c96f8c06cdb49d_9f119bc297"
                tabindex="-1"
                value=""/>
            </div>

            <BtnWrapper
              active={this.state.accepted}
              onClick={!this.state.accepted
              ? this.setShake
              : ""}>
              <input
                className={'button ' + this.props.page + 'sendToMC'}
                type={this.state.accepted
                ? "submit"
                : "button"}
                value="Gå med"
                name="subscribe"
                id="mc-embedded-subscribe"/>
            </BtnWrapper>
            {this.state.sent
              ? (
                <div>
                  <SmallMargin/>
                  <MediumTitle>Skickat!</MediumTitle>
                </div>
              )
              : ("")}
          </div>
        </form>
      </div>
    );
  }
}

class MailChimpModal extends Component {
  render() {
    return (
      <React.Fragment>
        <Background show={this.props.showContactModal}/>
        <ShowWrapper show={this.props.showContactModal}>
          <CloseWrapper onClick={this.props.setHideContactModal}>
            <X/>
          </CloseWrapper>
          <Wrapper>
            <div
              style={{
              color: grayText,
              flexShrink: "0",
              minHeight: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center"
            }}>
              <AttentionTitle>Intresseanmälan</AttentionTitle>
              <SmallMargin/>

              <InterestedBody
                page='Modal'
                setHideContactModal={this.props.setHideContactModal}/>
            </div>
          </Wrapper>
        </ShowWrapper>
      </React.Fragment>
    );
  }
}

export default MailChimpModal;



// WEBPACK FOOTER //
// ./src/Global/MailChimpModal.js